import { atom } from 'recoil';

export const isNewPersonModalOpenAtom = atom<boolean>({
  key: 'isNewPersonModalOpenState',
  default: false,
});
